<template>
  <div class="w-full flex justify-start items-center flex-col font-costea">
       <div class="w-full p-4 max-w-4xl mx-auto">
           <img class="w-28" :src="costea.logo" :alt="costea.logoAlt">
       </div>
       <div class="w-full max-w-4xl flex flex-col items-center mt-10 mb-8">
           <h1 class="text-h24 text-costeaBlack font-medium">¿Olvidaste tu contraseña?</h1>
           <h4 class="text-costeaDarkGray text-t16">Ingresa tu correo electrónico para restablecer tu contraseña</h4>
       </div>
       <form @submit.prevent="resetPassword()" class="w-full p-4 max-w-lg mx-auto mb-10">
           <div>
               <label for="email" class="text-t14 text-costeaDarkGray">Correo electrónico</label>
                <input id="email" required v-model="email" type="email" class="bg-costeaContainer w-full h-12 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="user@example.com">
           </div>
           <div class="mt-4">
               <label for="team" class="text-t14 text-costeaDarkGray">Nombre del equipo</label>
                <input id="team" required v-model="team_word" type="text" class="bg-costeaContainer w-full h-12 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="costea">
           </div>
           <div class="mt-4 mb-4 flex flex-col items-center">
               <input class="bg-costeaPrimary px-4 py-2 w-full mb-6 rounded-md text-white hover:bg-costeaHover cursor-pointer" type="submit" value="Restablecer contraseña">
               <span class="text-t14 text-costeaDarkGray mb-1">¿Recordaste tu contraseña?</span>
               <router-link :to="{name:'login'}" class="underline text-t14 text-costeaGray cursor-pointer hover:text-costeaPrimary">Iniciar sesión</router-link>
           </div>
       </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
export default {
data(){
    return{
        email: '',
        team_word: ''
    }
},
computed:{
    ...mapState(['costea'])
},
methods:{
    resetPassword(){
        axios.post(`${this.costea.protocol}${this.team_word}.backend.costea.com.co/api/v1/forgot-password`,{'email':this.email}).then(()=>{
            this.$router.push('/login')
        }).catch((error)=>{
            console.log(error)
        })
    }

}
}
</script>

<style>

</style>